import React from "react";
import { Col, Container, Row } from "reactstrap";
import VideoLugar from "../../assets/img/ensuenio-lugar.mp4";

function NuestroEspacio(props) {
  return (
    <>
      <section className="section section-lg pt-6 bg-secondary mt-5">
        <Container className="mb-6">
          <Row className="row-grid align-items-center">
            <Col lg="12">
              <div className="pl-4 align-component-enter">
                <h4 className="display-3">Nuestro Lugar</h4>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4 mb-5">
            <Col lg="10">
              <video
                controls
                style={{ width: "100%", borderRadius: "8px" }}
              >
                <source src={VideoLugar} type="video/mp4" />
              </video>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default NuestroEspacio;
